(function () {
  'use strict';

  const money = (cents) => {
    const value = (Number(cents) || 0) / 100;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(Number(cents) || 0);
      } catch (e) { /* fall through */ }
    }
    return 'Rs.' + value.toLocaleString('en-PK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const formatSave = (cents, prefix) => {
    const label = prefix || 'Save';
    return label + ' ' + money(cents);
  };

  const esc = (str) => String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const cartRoot = () => (
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/'
  );

  function openCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer) {
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('hidden');
    }
    if (overlay) overlay.classList.add('cart-overlay--visible');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer) {
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('cart-overlay--visible');
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const body = document.getElementById('cart-drawer-body');
        const footer = document.getElementById('cart-drawer-footer');
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = String(cart.item_count || 0);
        if (!body) return cart;

        if (!cart.item_count) {
          body.innerHTML =
            '<div class="cart-empty">' +
            '<p><span class="i18n-ur">آپ کا کارٹ خالی ہے۔</span><span class="i18n-en">Your cart is empty.</span></p>' +
            '<button type="button" class="btn btn--primary" data-cart-close>' +
            '<span class="i18n-ur">خریداری شروع کریں</span><span class="i18n-en">Start Shopping</span>' +
            '</button></div>';
          if (footer) {
            footer.innerHTML = '';
            footer.hidden = true;
          }
          return cart;
        }

        const items = (cart.items || []).map((item) => {
          const img = item.image
            ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" width="100" height="100" loading="lazy">'
            : '';
          const variant = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>'
            : '';
          return (
            '<li class="cart-item">' +
            '<div class="cart-item__img">' + img + '</div>' +
            '<div class="cart-item__info">' +
            '<p class="cart-item__title">' + esc(item.product_title) + '</p>' +
            variant +
            '<p class="cart-item__price">' + money(item.final_line_price) + '</p>' +
            '<div class="cart-item__qty-row"><span class="qty-val">' + item.quantity + '</span></div>' +
            '</div></li>'
          );
        }).join('');

        body.innerHTML = '<ul class="cart-items">' + items + '</ul>';

        if (footer) {
          footer.innerHTML =
            '<div class="cart-total-row">' +
            '<span><span class="i18n-ur">کل رقم</span><span class="i18n-en">Subtotal</span></span>' +
            '<span class="cart-total-amount">' + money(cart.total_price) + '</span></div>' +
            '<p class="cart-shipping-note">' +
            '<span class="i18n-ur">ڈیلیوری چیک آؤٹ پر مفت</span>' +
            '<span class="i18n-en">Free delivery — shipping at checkout</span></p>' +
            '<a href="' + esc(cartRoot()) + 'checkout" class="btn btn--primary btn--full btn--lg">' +
            '<span class="i18n-ur">چیک آؤٹ</span><span class="i18n-en">Checkout</span></a>' +
            '<a href="' + esc(cartRoot()) + 'cart" class="btn btn--outline btn--full" style="margin-top:10px">' +
            '<span class="i18n-ur">کارٹ دیکھیں</span><span class="i18n-en">View cart</span></a>';
          footer.hidden = false;
        }
        return cart;
      });
  }

  function initPlans() {
    const cards = Array.from(document.querySelectorAll('.plan-card'));
    if (!cards.length) return;

    const compareEl = document.querySelector('[data-compare-price]');
    const currentEl = document.querySelector('[data-current-price]');
    const saveEl = document.querySelector('[data-save-badge]');
    const variantInput = document.querySelector('[data-variant-input]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    const activate = (card) => {
      cards.forEach((c) => {
        c.classList.toggle('plan-card--active', c === card);
        c.setAttribute('aria-pressed', c === card ? 'true' : 'false');
      });

      const price = card.dataset.price;
      const compare = card.dataset.compare;
      const save = card.dataset.save;
      const variant = card.dataset.variant;

      if (compareEl) compareEl.textContent = money(compare);
      if (currentEl) currentEl.textContent = money(price);
      if (saveEl) {
        const prefix = saveEl.dataset.savePrefix || 'Save';
        saveEl.textContent = formatSave(save, prefix);
      }
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (variantInput && variant) variantInput.value = variant;
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => activate(card));
    });

    document.querySelectorAll('[data-select-plan]').forEach((row) => {
      row.addEventListener('click', () => {
        const plan = row.getAttribute('data-select-plan');
        const match = cards.find((c) => c.dataset.plan === plan);
        if (match) activate(match);
        const hero = document.getElementById('buy-section');
        if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initQty() {
    const input = document.getElementById('qty-input');
    const formQty = document.querySelector('[data-form-qty]');
    const minus = document.querySelector('[data-qty-minus]');
    const plus = document.querySelector('[data-qty-plus]');
    if (!input) return;

    const sync = () => {
      if (formQty) formQty.value = input.value;
    };

    minus && minus.addEventListener('click', () => {
      const next = Math.max(1, Number(input.value) - 1);
      input.value = String(next);
      sync();
    });

    plus && plus.addEventListener('click', () => {
      const next = Math.min(20, Number(input.value) + 1);
      input.value = String(next);
      sync();
    });

    sync();
  }

  function initStickyCta() {
    const sticky = document.querySelector('[data-sticky-cta]');
    const hero = document.getElementById('buy-section');
    const stickyBtn = document.querySelector('[data-sticky-atc]');
    const form = document.getElementById('product-form');
    if (!sticky || !hero) return;

    const onScroll = () => {
      const rect = hero.getBoundingClientRect();
      const past = rect.bottom < 80;
      sticky.classList.toggle('sticky-mobile-cta--hidden', !past);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    stickyBtn && stickyBtn.addEventListener('click', () => {
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      } else {
        hero.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  function initCartDrawer() {
    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-cart-open]');
      if (openBtn) {
        event.preventDefault();
        refreshCartDrawer().finally(openCart);
        return;
      }
      const closeBtn = event.target.closest('[data-cart-close]');
      if (closeBtn) {
        event.preventDefault();
        closeCart();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCart();
    });
  }

  function initMobileNav() {
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    const backdrop = document.querySelector('[data-mobile-nav-backdrop]');
    if (!toggle || !nav) return;

    const close = () => {
      nav.hidden = true;
      nav.classList.remove('mobile-nav--open');
      if (backdrop) {
        backdrop.hidden = true;
        backdrop.classList.remove('mobile-nav-backdrop--open');
        backdrop.setAttribute('aria-hidden', 'true');
      }
      toggle.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
      nav.hidden = false;
      nav.classList.add('mobile-nav--open');
      if (backdrop) {
        backdrop.hidden = false;
        backdrop.classList.add('mobile-nav-backdrop--open');
        backdrop.setAttribute('aria-hidden', 'false');
      }
      toggle.setAttribute('aria-expanded', 'true');
    };

    toggle.addEventListener('click', () => {
      if (nav.classList.contains('mobile-nav--open')) close();
      else open();
    });
    backdrop && backdrop.addEventListener('click', close);
    nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
  }

  function initHeaderSearch() {
    const root = document.querySelector('[data-header-search]');
    if (!root) return;
    const toggle = root.querySelector('[data-search-toggle]');
    const form = root.querySelector('[data-search-form]');
    const input = root.querySelector('[data-search-input]');
    const closeBtn = root.querySelector('[data-search-close]');
    if (!toggle || !form || !input) return;

    const open = () => {
      root.classList.add('is-open');
      form.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => input.focus(), 10);
    };
    const close = () => {
      root.classList.remove('is-open');
      form.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      if (root.classList.contains('is-open')) close();
      else open();
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        close();
        toggle.focus();
      });
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        close();
        toggle.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!root.classList.contains('is-open')) return;
      if (!root.contains(event.target)) close();
    });
  }

  async function buyNowCheckout(form) {
    const btn = form.querySelector('[type="submit"]');
    const stickyBtn = document.querySelector('[data-sticky-atc]');
    const original = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Going to checkout…';
    }
    if (stickyBtn) stickyBtn.disabled = true;

    try {
      const formData = new FormData(form);
      const id = formData.get('id');
      if (!id) throw new Error('Missing variant id');

      // Buy Now: start fresh with this product only, then go straight to checkout.
      await fetch(cartRoot() + 'cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      const res = await fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: formData
      });

      const payload = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(payload.description || payload.message || 'Checkout failed');
      }

      window.location.href = cartRoot() + 'checkout';
    } catch (err) {
      console.error('Buy now / checkout failed', err);
      // Fallback: native add with return_to checkout
      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = '/checkout';
      form.removeEventListener('submit', onProductSubmit);
      form.submit();
    } finally {
      // Keep disabled while navigating; restore only if we stayed on the page
      window.setTimeout(() => {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = original;
        }
        if (stickyBtn) stickyBtn.disabled = false;
      }, 4000);
    }
  }

  function onProductSubmit(event) {
    event.preventDefault();
    buyNowCheckout(event.currentTarget);
  }

  function initAjaxAtc() {
    const form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', onProductSubmit);
  }

  function duplicateAnnouncement() {
    const track = document.querySelector('[data-announcement-track]');
    if (!track || track.dataset.cloned) return;
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.cloned = '1';
  }

  function initLangFallback() {
    const wrap = document.querySelector('[data-lang-fallback]');
    if (!wrap) return;
    const chips = wrap.querySelectorAll('[data-set-lang]');
    const apply = (lang) => {
      document.body.classList.remove('lang-ur', 'lang-en');
      document.body.classList.add('lang-' + lang);
      document.documentElement.lang = lang;
      chips.forEach((c) => {
        c.classList.toggle('is-active', c.getAttribute('data-set-lang') === lang);
      });
      try { localStorage.setItem('hbp_lang_preview', lang); } catch (e) {}
    };
    chips.forEach((chip) => {
      chip.addEventListener('click', () => apply(chip.getAttribute('data-set-lang')));
    });
    let saved = 'en';
    try { saved = localStorage.getItem('hbp_lang_preview') || 'en'; } catch (e) {}
    apply(saved === 'ur' ? 'ur' : 'en');
  }

  window.HBP = { openCart, closeCart, refreshCartDrawer };

  function initFadeIns() {
    const nodes = document.querySelectorAll('.fade-ready');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('fade-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('fade-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    nodes.forEach((el) => io.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPlans();
    initQty();
    initStickyCta();
    initCartDrawer();
    initMobileNav();
    initHeaderSearch();
    initAjaxAtc();
    duplicateAnnouncement();
    initLangFallback();
    initFadeIns();
  });
})();

